import styled, {keyframes} from 'styled-components';

export const CenteredSpaceWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:space-between;
    `,
);

export const CenteredDivWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:center;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const FlexWrap = styled.div(
  props => `
    display:flex;
    `,
);

export const FlexItemCenter = styled.div(
  props => `
    display:flex;
    align-items: ${props.alignitem || 'center'};
    `,
);

export const HeaderStyle = styled.h2(
  props => `
    font-size: ${props.theme.font.large};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
    `,
);

export const SubHeaderStyle = styled.h3(
  props => `
    font-size: ${props.theme.font.custom(16)};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
    `,
);

export const SmallHeaderStyle = styled.h4(
  props => `
    font-size: ${props.theme.font.custom(14)};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
    `,
);

export const InnerSpacingStyle = styled.div(
  props => `
  background: ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.custom(8)};
  `,
);

export const ContainerFixedStyle = styled.div(
  props => `
  background: ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.custom(95)} ${props.theme.spacing.custom(
    8,
  )} ${props.theme.spacing.custom(8)};
  `,
);

export const CardWrap = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  background: ${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.xlarge};
  margin-bottom:${props.theme.spacing.custom(8)};
  padding: ${props.theme.spacing.custom(12)};
  width: 100%;
  `,
);

export const FooterContainerStyle = styled.div(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.custom(4)};
  position: fixed;
  width: 100%;
  bottom:0;
  box-shadow: 0 .1rem .5rem 0 ${props.theme.colors.shadow.dark};
  `,
);

/*** Shimmer Loader ***/

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }

  100% {
    background-position: 46.8rem 0;
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
  margin-bottom: ${props => props.theme.spacing.small};
  height: 1rem;
`;

export const FlipUpsideDown = styled.div`
  transform: rotate(180deg);
`;

export const CircleBulletForLists = styled.div(
  props => `
  width: ${props.width || '0.5rem'};
  height:  ${props.height || '0.5rem'};
  background:  ${props.color || 'black'};
  border-radius: 50%;
  margin: ${props.margin || '0 0.5rem 0 0'};
`,
);
